export default {"src":"/_next/static/media/DAI.1ffb6af1.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};